<dx-load-panel [(visible)]="isLoading" [showIndicator]="true" [showPane]="false" [shading]="true"
    [hideOnOutsideClick]="false" [position]="{ of: '.demo-container' }" shadingColor="rgba(0,0,0,0.4)">
</dx-load-panel>